import { c as _c } from "react/compiler-runtime";
import { Pt_PaymentModel } from '@/modules/__generated__/graphql/switchboard-generated';
import { ProposalCardOutline } from './proposal-card-outline';
const PAYMENT_MODEL_LABELS: Record<Pt_PaymentModel, string> = {
  [Pt_PaymentModel.Retainer]: 'Retainer',
  [Pt_PaymentModel.Milestone]: 'Milestone',
  [Pt_PaymentModel.CostAndMaterials]: 'Cost & Materials'
};
const ALL_PAYMENT_MODELS = Object.values(Pt_PaymentModel);
function PaymentTermsCard() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProposalCardOutline title="Payment Terms" className="gap-8"><div className="flex flex-wrap justify-between gap-2 gap-y-3 px-6 text-center text-sm/5.5 uppercase [&>div]:flex-1 [&>div]:whitespace-nowrap">{ALL_PAYMENT_MODELS.map(_temp)}</div></ProposalCardOutline>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(model) {
  return <div key={model}>{PAYMENT_MODEL_LABELS[model]}</div>;
}
export { PaymentTermsCard };